import * as React from 'react';
import { Row } from "reactstrap";
import { ICase } from 'src/share/types/case/case';
import { momentToString } from 'src/share/utils/utils';

export interface ICaseInformationProps {
  caseInfo: ICase
}

export default class CaseInformation extends React.PureComponent<ICaseInformationProps> {
  public render() {
    const { openDate, city, country } = this.props.caseInfo
    const location = `${city ? city + ', ' : ""}${country}`;
    return (
      <>
        <Row>
          <h5 className="alert-case-open-date">Case open date: <b>{openDate && momentToString(openDate)}</b></h5>
        </Row>
        <Row>
          <h5 className="text-title">Case Location:</h5>
          <p className="text-content">{location}</p>
        </Row>
      </>
    );
  }
}




// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/CaseInfo.tsx